import { render, staticRenderFns } from "./FeatureCardDataRow.vue?vue&type=template&id=bb39f76c&scoped=true&"
import script from "./FeatureCardDataRow.vue?vue&type=script&lang=js&"
export * from "./FeatureCardDataRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb39f76c",
  null
  
)

export default component.exports